import React from 'react'
import Link from 'gatsby-link'
import './Header.scss'

export default function Header(props) {
  return (
    <header id={'site-header'}>
      <h2>
        <Link to={'/'}>Rob Bayliss</Link>
      </h2>
    </header>
  )
}



// WEBPACK FOOTER //
// ./src/components/Header.js